var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"gaoBaoBanLoginRoot"}},[_c('KeepAlive',[_c('router-view')],1)],1),_vm._v(" "),(_vm.$store.state.showLoading)?_c('Loading'):_vm._e(),_vm._v(" "),(_vm.$store.state.showToast)?_c('Toast'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd68470","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GaoBaoBan/GaoBaoBanLogin.vue
// module id = null
// module chunks = 